import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { name: '智能剪辑', path: '/articles/beginner-guide-ai-video-creation' },
      { name: 'AI配音', path: '/articles/luobo-video-2-0-update' },
      { name: '自动字幕', path: '/articles/beginner-guide-ai-video-creation' },
      { name: '定价方案', path: '/about' },
    ],
  },
  resources: {
    title: '资源',
    links: [
      { name: '创作教程', path: '/articles?category=tutorial' },
      { name: '技巧攻略', path: '/articles?category=tips' },
      { name: '案例分享', path: '/articles?category=case-studies' },
      { name: '帮助中心', path: '/about' },
    ],
  },
  company: {
    title: '公司',
    links: [
      { name: '关于我们', path: '/about' },
      { name: '联系我们', path: '/about' },
      { name: '用户口碑', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14 md:py-18">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-white text-sm font-bold">
                  萝
                </span>
                <span className="text-lg font-heading font-bold text-white">萝卜视频</span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-400">
                智能AI视频创作平台，让每个人都能轻松制作专业级视频内容。一键生成、剪辑、配音与字幕，解锁高效视频创作新方式。
              </p>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="text-sm font-semibold text-white mb-4">{section.title}</h4>
                <ul className="space-y-3">
                  {section.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-white transition-colors cursor-pointer"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-foreground-800/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              &copy; 2026 萝卜视频. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-foreground-500 hover:text-white transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-white transition-colors cursor-pointer">服务条款</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-white transition-colors cursor-pointer">Cookie设置</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}